import React from "react";
import PropTypes from "prop-types";
import { DatePicker as AntDatePicker } from "antd";
import { UiDatePicker } from "./DatePicker.style";
/**
 * 日期組件
 */

const {
  RangePicker
} = AntDatePicker;

const DatePicker = ({
  defaultValue,
  variant,
  onChange
}) => {
  const onDateChange = (date, dateString) => {
    onChange && onChange(date, dateString);
  };

  return /*#__PURE__*/React.createElement(UiDatePicker, {
    variant: variant
  }, /*#__PURE__*/React.createElement(RangePicker, {
    defaultValue: defaultValue,
    onChange: (date, dateString) => {
      onDateChange(date, dateString);
    }
  }));
};

export default DatePicker;
DatePicker.propTypes = {
  defaultValue: PropTypes.array,
  variant: PropTypes.string,
  onChange: PropTypes.func
};